import apiV2 from '../api/v2';

// Accounts > Practice detail > Overview tab's "Communications by category"
// card (and its global counterpart on the Accounts Overview hub).
export interface CommunicationCategoryCount {
    category: string;
    count: number;
}

// Server owns sort + zero-count omission. `practiceId` omitted means global.
export async function fetchCommunicationCategoryCounts(
    days: number,
    practiceId?: string
): Promise<CommunicationCategoryCount[]> {
    const response = await apiV2.get<{
        success: true;
        data: { counts: CommunicationCategoryCount[] };
    }>('/practices/communications/category-counts', { params: { practice: practiceId, days } });
    return response.data.data.counts;
}
